// extracted by mini-css-extract-plugin
export default {"vanPageHeaderContainer":"styles_vanPageHeaderContainer__YVQEZ","inputsContainer":"styles_inputsContainer__ByOsM","margin":"styles_margin__SoR8Z"};